export default "__VITE_ASSET__CaJST$NH__"